import { Component } from "@angular/core";

@Component({
  selector: "brd-session-expired",
  templateUrl: "./session-expired.component.html",
  styleUrls: ["./session-expired.component.less"]
})
export class SessionExpiredComponent {
  constructor() {}

  redirect(): void {
    window.location.href = "/";
  }
}
